import {
    IAgendaTecnicoRequest,
    IAgendamento,
    IEditAgendaCompromisso,
    IFiltroListarAgendamento,
} from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import {
    AlterarAgendamentoService,
    CriarAgendamentoDeAtendimentoService,
    DeletarAgendamentoDeAtendimentoService,
    ListarAgendaTecnicoService,
    ListarAgendamentosDeAtendimentoService,
    ListarAgendamentosService,
    ListarCasoVinculadosAgendamentoService,
    ListarCompromissoDisponiveisVistoriaAgendaService,
    MarcarAgendamentoConcluidoService,
} from "../../../Services/AssistenciaTecnica/Agendamento/AgendamentoServices";
import { Controller } from "../../Controller";

export function ListarAgendamentosDeAtendimentoController(idCaso: number) {
    return Controller(ListarAgendamentosDeAtendimentoService(idCaso));
}

export function ListarCompromissoDisponiveisVistoriaAgendaController(
    DT_INICIO: string | Date,
    DT_FIM: string | Date,
    ID_TIPO_COMPROMISSO?: number,
    ID_PRODUTO?: number,
    ID_USUARIO?: number,
    NR_QUANTIDADE_DIA?: number
) {
    return Controller(
        ListarCompromissoDisponiveisVistoriaAgendaService(
            DT_INICIO,
            DT_FIM,
            ID_TIPO_COMPROMISSO,
            ID_PRODUTO,
            ID_USUARIO,
            NR_QUANTIDADE_DIA
        )
    );
}

export function ListarAgendaTecnicoController(
    requestBody: IAgendaTecnicoRequest
) {
    return Controller(ListarAgendaTecnicoService(requestBody));
}

export function CriarAgendamentoDeAtendimentoController(
    requestBody: IAgendamento,
    idCompromissoDisponivelVistoria?: number
) {
    return Controller(
        CriarAgendamentoDeAtendimentoService(
            requestBody,
            idCompromissoDisponivelVistoria
        )
    );
}

export function ListarAgendamentosController(filtro: IFiltroListarAgendamento) {
    return Controller(ListarAgendamentosService(filtro));
}
export function DeletarAgendamentoDeAtendimentoController(
    ID_COMPROMISSO: number
) {
    return Controller(DeletarAgendamentoDeAtendimentoService(ID_COMPROMISSO));
}

export function ListarCasoVinculadosAgendamentoController(
    idCompromisso: number
) {
    return Controller(ListarCasoVinculadosAgendamentoService(idCompromisso));
}

export function AlterarAgendamentoController(
    requestBody: IEditAgendaCompromisso
) {
    return Controller(AlterarAgendamentoService(requestBody));
}

export function MarcarAgendamentoConcluidoController(
    ID_COMPROMISSO: number,
    DT_FIM: string
) {
    return Controller(
        MarcarAgendamentoConcluidoService(ID_COMPROMISSO, DT_FIM)
    );
}
